/**
 * Walk up from `node` looking for the nearest scrollable ancestor whose
 * content actually overflows. Falls back to `window` so dragging in a
 * long page still auto-scrolls the viewport.
 */
export function findScrollContainer(
  node: HTMLElement | null
): HTMLElement | Window {
  let el: HTMLElement | null = node?.parentElement ?? null;
  while (el && el !== document.body && el !== document.documentElement) {
    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    const overflowX = style.overflowX;
    const scrollsY =
      (overflowY === "auto" || overflowY === "scroll") &&
      el.scrollHeight > el.clientHeight;
    const scrollsX =
      (overflowX === "auto" || overflowX === "scroll") &&
      el.scrollWidth > el.clientWidth;
    if (scrollsY || scrollsX) return el;
    el = el.parentElement;
  }
  return window;
}
